var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.371 1.75L4.871 3.25H2V12.25H14V3.25H11.129L9.629 1.75H6.371ZM5.75 0.25H10.25L11.75 1.75H14.75C14.9489 1.75 15.1397 1.82902 15.2803 1.96967C15.421 2.11032 15.5 2.30109 15.5 2.5V13C15.5 13.1989 15.421 13.3897 15.2803 13.5303C15.1397 13.671 14.9489 13.75 14.75 13.75H1.25C1.05109 13.75 0.860322 13.671 0.71967 13.5303C0.579018 13.3897 0.5 13.1989 0.5 13V2.5C0.5 2.30109 0.579018 2.11032 0.71967 1.96967C0.860322 1.82902 1.05109 1.75 1.25 1.75H4.25L5.75 0.25ZM8 11.5C6.90598 11.5 5.85677 11.0654 5.08318 10.2918C4.3096 9.51823 3.875 8.46902 3.875 7.375C3.875 6.28098 4.3096 5.23177 5.08318 4.45818C5.85677 3.6846 6.90598 3.25 8 3.25C9.09402 3.25 10.1432 3.6846 10.9168 4.45818C11.6904 5.23177 12.125 6.28098 12.125 7.375C12.125 8.46902 11.6904 9.51823 10.9168 10.2918C10.1432 11.0654 9.09402 11.5 8 11.5ZM8 10C8.69619 10 9.36387 9.72344 9.85616 9.23116C10.3484 8.73887 10.625 8.07119 10.625 7.375C10.625 6.67881 10.3484 6.01113 9.85616 5.51884C9.36387 5.02656 8.69619 4.75 8 4.75C7.30381 4.75 6.63613 5.02656 6.14384 5.51884C5.65156 6.01113 5.375 6.67881 5.375 7.375C5.375 8.07119 5.65156 8.73887 6.14384 9.23116C6.63613 9.72344 7.30381 10 8 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.f5ab840d089a3174c5e86db468c6f822.svg";
export { ForwardRef as ReactComponent };